import React from 'react'

import { Form, Input, Select, InputNumber } from 'antd'
import PropTypes from 'prop-types'
import { EnFormItem } from '../shared/LocalizedFields'

const InstrumentForm = ({
  form,
  nameKZ,
  nameRU,
  nameEN,
  descriptionKZ,
  descriptionRU,
  descriptionEN,
  status,
  index,
  setFile,
  fileRef
}) => {
  const FormItem = Form.Item
  return (
    <Form form={form} layout="vertical" hideRequiredMark>
      <>Изорбражение</>
      <input
        style={{ marginBottom: '3%' }}
        type="file"
        accept="image/*"
        ref={fileRef}
        onChange={event => setFile(event.target.files[0])}
      />
      <FormItem
        key="status"
        label="Статус документа"
        name="status"
        rules={[
          {
            required: true,
            message: `Пожалуйста, выберите статус`
          }
        ]}
        initialValue={status}
      >
        <Select placeholder="Выберите" mode="single">
          <Select.Option key="active" value="active">
            Автивный
          </Select.Option>
          <Select.Option key="inactive" value="inactive">
            Скрытый
          </Select.Option>
        </Select>
      </FormItem>
      <FormItem
        key="index"
        label="Очередность"
        name="index"
        rules={[
          {
            required: true,
            message: `Пожалуйста, введите Очередность`
          }
        ]}
        initialValue={index}
      >
        <InputNumber min={1} placeholder="Очередность" />
      </FormItem>
      <FormItem
        key="nameKZ"
        label="Название(каз)"
        name="nameKZ"
        rules={[
          {
            required: true,
            message: `Пожалуйста, введите название Инструмента на казахском`
          }
        ]}
        initialValue={nameKZ}
      >
        <Input placeholder="Аты" />
      </FormItem>
      <FormItem
        key="nameRU"
        label="Название(рус)"
        name="nameRU"
        rules={[
          {
            required: true,
            message: `Пожалуйста, введите название Инструмента на русском`
          }
        ]}
        initialValue={nameRU}
      >
        <Input placeholder="Название" />
      </FormItem>
      <EnFormItem name="nameEN" label="Название(англ)" initialValue={nameEN} />
      <FormItem
        key="descriptionKZ"
        label="Описание(каз)"
        name="descriptionKZ"
        rules={[
          {
            required: false,
            message: `Пожалуйста, напишите описание Инструмента на казахском`
          }
        ]}
        initialValue={descriptionKZ}
      >
        <Input.TextArea placeholder="Описание(каз)" />
      </FormItem>
      <FormItem
        key="descriptionRU"
        label="Описание(рус)"
        name="descriptionRU"
        rules={[
          {
            required: false,
            message: `Пожалуйста, напишите описание Инструмента на русском`
          }
        ]}
        initialValue={descriptionRU}
      >
        <Input.TextArea placeholder="Описание(рус)" />
      </FormItem>
      <EnFormItem
        name="descriptionEN"
        label="Описание(англ)"
        initialValue={descriptionEN}
        multiline
      />
    </Form>
  )
}

InstrumentForm.propTypes = {
  form: PropTypes.objectOf(PropTypes.any).isRequired,
  name: PropTypes.string
}

InstrumentForm.defaultProps = {
  nameKZ: '',
  nameRU: '',
  nameEN: '',
  descriptionKZ: null,
  descriptionRU: null,
  descriptionEN: null,
  status: 'active',
  index: null
}

export default InstrumentForm
